import styles from './ScoopRow.module.scss'

/**
 * ScoopRow - Horizontal flex container component
 *
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child elements
 * @param {string} [props.className=''] - Additional CSS classes
 * @param {string|number} [props.gap] - Gap between children (e.g., '8px', 16, '1rem')
 * @param {'flex-start'|'flex-end'|'center'|'stretch'|'baseline'} [props.align] - align-items value
 * @param {'flex-start'|'flex-end'|'center'|'space-between'|'space-around'|'space-evenly'} [props.justify] - justify-content value
 * @param {boolean} [props.wrap=false] - Enable flex-wrap
 * @param {boolean} [props.fullWidth=false] - Set width to 100%
 * @param {boolean} [props.fullHeight=false] - Set height to 100%
 * @param {Object} [props.style] - Additional inline styles
 * @param {Object} props...rest - Additional HTML div props
 */
export const ScoopRow = ({
    children,
    className = '',
    gap,
    align,
    justify,
    wrap = false,
    fullWidth = false,
    fullHeight = false,
    style,
    ...rest
}) => {
    const inlineStyles = {
        ...(gap !== undefined && { gap: typeof gap === 'number' ? `${gap}px` : gap }),
        ...(align && { alignItems: align }),
        ...(justify && { justifyContent: justify }),
        ...(wrap && { flexWrap: 'wrap' }),
        ...(fullWidth && { width: '100%' }),
        ...(fullHeight && { height: '100%' }),
        ...style,
    }

    const hasInlineStyles = Object.keys(inlineStyles).length > 0

    return (
        <div
            className={`${styles.row} ${className}`.trim()}
            style={hasInlineStyles ? inlineStyles : undefined}
            {...rest}
        >
            {children}
        </div>
    )
}

export default ScoopRow
